import { render } from "./ClaimCoverageInformation.vue?vue&type=template&id=3f805c99"
import script from "./ClaimCoverageInformation.vue?vue&type=script&lang=js"
export * from "./ClaimCoverageInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__